/// <amd-module name="Environments/EnvironmentTraceabilityWorkItems/ActionsCreators/WorkitemsActionsCreator" />
import { ActionCreatorBase } from "Environments/Flux/ActionCreatorBase";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { WorkitemsActions } from "Environments/EnvironmentTraceabilityWorkItems/Actions/WorkitemsActions";
import { MessagesActions } from "Environments/EnvironmentsCommon/MessagesActions";
import { IEnvironmentService } from "Environments/Client/EnvironmentService";
import { PageContextHelper } from "Environments/Client/PageContextHelper";
import { WorkItemTrackingClientName, IWorkItemTrackingRestClient } from "Environments/RemoteClients/WorkItemTracking";
import { WorkItemType } from "Environments/RemoteClients/Contracts/WorkItemTracking";
import { IWorkitemsResult } from "Environments/Client/EnvironmentContracts";

import { IVssPageContext } from "VSS/Platform/Context";

const WorkitemsView: string = "environments";

export class WorkitemsActionsCreator extends ActionCreatorBase {

    public static getKey(): string {
        return "workitems-action-creator";
    }

    public initialize(instanceId?: string) {
        super.initialize(instanceId);
        
        this._actions = ActionsHubManager.CreateActionsHub<WorkitemsActions>(WorkitemsActions, instanceId);
        this._messageActions = ActionsHubManager.CreateActionsHub<MessagesActions>(MessagesActions, instanceId);
    }

    public getWorkitems(pageContext: IVssPageContext): boolean {
        const environmentService = pageContext.getService<IEnvironmentService>("IEnvironmentService");
        let workitemsResult: IWorkitemsResult | undefined = environmentService.getWorkitems();
        
        if (!!workitemsResult) {
            this._actions.setWorkitems.invoke(workitemsResult);
            return true;
        }

        environmentService.getWorkitemsAsync().then((workItemsResult : IWorkitemsResult) => {
            this._actions.setWorkitems.invoke(workItemsResult);
        },
        (error) => {
            this._messageActions.addMessage.invoke({ key: WorkitemsView, value: error });
        });

        return false;
    }

    public getWorkitemsAsync(pageContext: IVssPageContext): boolean {
        const environmentService = pageContext.getService<IEnvironmentService>("IEnvironmentService");

        environmentService.getWorkitemsAsync("2500").then((workItemsResult : IWorkitemsResult) => {
            this._actions.setWorkitems.invoke(workItemsResult);
        },
        (error) => {
            this._messageActions.addMessage.invoke({ key: WorkitemsView, value: error });
        });

        return false;
    }

    public getIcons(pageContext: IVssPageContext): void {
        const witRestClient = pageContext.getRestClient<IWorkItemTrackingRestClient>(WorkItemTrackingClientName);
        witRestClient.getWorkItemTypes(PageContextHelper.getProjectName(pageContext) as string).then((workitemTypes:  WorkItemType[]) => {
            this._actions.setIcons.invoke(workitemTypes);
        },
        (error) => {
            this._messageActions.addMessage.invoke({ key: WorkitemsView, value: error });
        });
    }

    protected disposeInternal(): void {
        ActionsHubManager.DeleteActionsHub<WorkitemsActions>(WorkitemsActions, this.getInstanceId());
        ActionsHubManager.DeleteActionsHub<MessagesActions>(MessagesActions, this.getInstanceId());
    }

    private _actions: WorkitemsActions;
    private _messageActions: MessagesActions;
}
